export const environment = {
    production: true,
    apiUrl: 'https://betaapi.truefaith.life/api/admin/',
};
